module.exports = __webpack_public_path__ + "static/img/iconMrWedensday.a6b7999.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconMrWedensday.svg
// module id = YpCP
// module chunks = 1